import { Component, ElementRef, Input, Renderer2, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-type-delete',
  templateUrl: './type-delete.component.html',
  styleUrls: ['./type-delete.component.scss']
})
export class TypeDeleteComponent {
  @ViewChild("textElement") textElement: ElementRef;
  @ViewChild("blinkElement") blinkElement: ElementRef;
  @ViewChild('wrapperElement') wrapperElement: ElementRef;

  @Input() wordArray: string[] = [
    "You Can...",
    "Write Anything You want...",
  ];
  @Input() textColor = "black";
  @Input() fontSize = "20px";
  @Input() blinkWidth = "2px";
  @Input() blinkColor = '#fff';
  @Input() textBackgroundColor = '#fff';
  @Input() typingSpeedMilliseconds = 300;
  @Input() deleteSpeedMilliseconds = 300;
  @Input() delay = 300;
  isDelayed = false;

  private index = 0;

  constructor(private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.initVariables();
    this.typingEffect();
  }

  initVariables(): void {
    // wrapper element
    this.renderer.setStyle(
      this.wrapperElement.nativeElement,
      'background-color',
      this.textBackgroundColor
    )
    // text element
    this.renderer.setStyle(
      this.textElement.nativeElement,
      "color",
      this.textColor
    );
    this.renderer.setStyle(
      this.textElement.nativeElement,
      "font-size",
      this.fontSize
    );
    this.renderer.setStyle(
      this.textElement.nativeElement,
      'color',
      this.textColor
    );
    // blink element
    this.renderer.setStyle(
      this.blinkElement.nativeElement,
      "width",
      this.blinkWidth
    );
    this.renderer.setStyle(
      this.blinkElement.nativeElement,
      "font-size",
      this.fontSize
    );
    this.renderer.setStyle(
      this.blinkElement.nativeElement,
      'color',
      this.blinkColor
    )
  }

  delayFunction() {
    this.isDelayed = true;
    return new Promise((resolve, reject)=> {
      setTimeout( () => {
        resolve(true);
        this.isDelayed = false;
      }, this.delay)
    })
  }

  private typingEffect(): void {
    if (this.wordArray && this.wordArray.length > 0) {
      const word = this.wordArray[this.index].split("");
      const loopTyping = () => {
        if (word.length > 0) {
          this.textElement.nativeElement.innerHTML += word.shift();
        } else {
          this.delayFunction().then(_ => {
            this.deletingEffect();
          })
          return;
        }
        setTimeout(loopTyping, this.typingSpeedMilliseconds);
      };
      loopTyping();
    }
  }

  private deletingEffect(): void {
    if (this.wordArray && this.wordArray.length > 0) {
      const word = this.wordArray[this.index].split("");
      const loopDeleting = () => {
        if (word.length > 0) {
          word.pop();
          this.textElement.nativeElement.innerHTML = word.join("");
        } else {
          if (this.wordArray.length > (this.index + 1)) {
            this.index += 1;
          } else {
            this.index = 0;
          }
          this.delayFunction().then(_=> {
            this.typingEffect();
          })
          return false;
        }
        setTimeout(loopDeleting, this.deleteSpeedMilliseconds);
      };
      loopDeleting();
    }
  }
}
